// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login-1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.frg-btn {
  text-decoration: none;
}
.sales-rights {
  background-position: center;
  background-size: cover;
  animation: image 2s infinite alternate;
  overflow-x: hidden;
}

@keyframes image {
  0% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  25% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  50% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  100% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}

.field-icon {
  float: right;
  margin-left: -25px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
}
.sales-left {
  /* background-color: #000B30;*/
  padding-top: 100px;
  height: 91.5vh;
}
.sales-left img {
  width: 145px;
  margin: 0 auto 25px;
  display: block;
}
.sales-right img {
  width: 100%;
  height: 91.5vh;
  margin: 0 auto;
  display: block;
}
.cpoy ul li {
  list-style: none;
  text-align: center;
  font-size: 12px;
  color: #d9a91d;
  padding-right: 37px;
  padding-top: 50px;
  padding-bottom: 5px;
}
.sales-left1 {
  padding: 0px;
}
.sales-right1 {
  padding: 0px;
}
.remember label {
  margin-bottom: 0px;
}
.frg-btn h6 {
  text-align: center;
  margin: 10px 0px;
  color: #f7a600;
}

.frg-btns {
  position: absolute;
  top: 133px;
  right: 28px;
  text-decoration: none;
}
.frg-btns h6 {
  font-size: 10px;
  color: #000;
}

.sales {
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Admin.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE;IACE,yDAAwD;EAC1D;EACA;IACE,yDAAwD;EAC1D;EACA;IACE,yDAAwD;EAC1D;EACA;IACE,yDAAwD;EAC1D;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".frg-btn {\r\n  text-decoration: none;\r\n}\r\n.sales-rights {\r\n  background-position: center;\r\n  background-size: cover;\r\n  animation: image 2s infinite alternate;\r\n  overflow-x: hidden;\r\n}\r\n\r\n@keyframes image {\r\n  0% {\r\n    background-image: url(\"../../assets/images/login-1.png\");\r\n  }\r\n  25% {\r\n    background-image: url(\"../../assets/images/login-1.png\");\r\n  }\r\n  50% {\r\n    background-image: url(\"../../assets/images/login-1.png\");\r\n  }\r\n  100% {\r\n    background-image: url(\"../../assets/images/login-1.png\");\r\n  }\r\n}\r\n\r\n.field-icon {\r\n  float: right;\r\n  margin-left: -25px;\r\n  margin-top: -25px;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n.sales-left {\r\n  /* background-color: #000B30;*/\r\n  padding-top: 100px;\r\n  height: 91.5vh;\r\n}\r\n.sales-left img {\r\n  width: 145px;\r\n  margin: 0 auto 25px;\r\n  display: block;\r\n}\r\n.sales-right img {\r\n  width: 100%;\r\n  height: 91.5vh;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n.cpoy ul li {\r\n  list-style: none;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  color: #d9a91d;\r\n  padding-right: 37px;\r\n  padding-top: 50px;\r\n  padding-bottom: 5px;\r\n}\r\n.sales-left1 {\r\n  padding: 0px;\r\n}\r\n.sales-right1 {\r\n  padding: 0px;\r\n}\r\n.remember label {\r\n  margin-bottom: 0px;\r\n}\r\n.frg-btn h6 {\r\n  text-align: center;\r\n  margin: 10px 0px;\r\n  color: #f7a600;\r\n}\r\n\r\n.frg-btns {\r\n  position: absolute;\r\n  top: 133px;\r\n  right: 28px;\r\n  text-decoration: none;\r\n}\r\n.frg-btns h6 {\r\n  font-size: 10px;\r\n  color: #000;\r\n}\r\n\r\n.sales {\r\n  overflow-x: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
